import { forkJoin as observableForkJoin, Observable, of as observableOf, Subscription } from 'rxjs';
import { catchError, filter, map, mergeMap, pluck, reduce, tap } from 'rxjs/operators';
import {
    faCaretDown,
    faCaretRight,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faSearch,
    IconDefinition
} from "@fortawesome/free-solid-svg-icons";


import get from 'lodash-es/get';
import forEach from 'lodash-es/forEach';
import isNumber from 'lodash-es/isNumber';
import isEqual from 'lodash-es/isEqual';
import {
    Component,
    EventEmitter, Inject,
    Input,
    OnDestroy,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Config } from './config';
import { GenericForm } from "libraries/module/formbuilder/forms/generic-the-good-one";
import { FormService } from "libraries/service/form/form.service";

import { IAfiGeoposition } from "libraries/service/geoposition/geoposition.model";
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import { SearchHotelFormService } from './services/search-hotel-form.service';
import { getFieldConfig } from './config/form';
import { WORDING } from './config/wording';
import { Checkbox } from 'primeng/checkbox';
import { DateService } from "libraries/date/date.service";
import {
    IRepartition,
    IRooming,
    ITravellerRepartition
} from "libraries/service/resources/configuration/ITravellerRepartitionConfig";
import { GeopositionService } from "libraries/service/geoposition/geoposition.service";
import { ISearchRequest, ITraveller, ITravellerObject } from "libraries/service/resources/hotel/ISearchParameters";
import { TravellerService } from "libraries/service/traveller/traveller.service";
import { IMultiselectOptions } from "libraries/module/formbuilder/fields/multiselect/multiselect.model";
import { ITag } from "libraries/service/resources/configuration/ITagConfig";
import { wenji } from "libraries/interfaces/IWenji";
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";
import { ILabels } from "libraries/interfaces/ILabels";
import { Yii } from 'libraries/interfaces/Yii';
import { HostAliasResource, IHostAlias } from "../../../service/resources/host-alias/host-alias.resource";
import { HttpClient } from "@angular/common/http";
import { ELabelPosition } from "libraries/module/formbuilder/fields/form-field/form-field.component";
import { ILocation } from "../../../interfaces/ISearchResponse";
import _isEqual from "lodash-es/isEqual";
import { EStayPermissions } from "../../../enums/e-stay-permissions";
import { LanguageService } from "libraries/service/language/language.service";
import {PermissionResourceService} from "../../../service/resources/permission/permissionResource.service";

interface IQuantity {
    adult?: number;
    child?: number;
    infant?: number;
    rooming?: number;
}

interface IValidators {
    [key: string]: boolean;
}

/**
 * validators
 */
function checkIfHasTextOrGeoposition(group: FormGroup): IValidators | null {
    const geoposition: AbstractControl = group.get(['geoposition', 'longitude']);
    const locationName: AbstractControl = group.get('locationName');
    const text: AbstractControl = group.get('text');
    return text.value || locationName.value || geoposition.value ? null : {checkIfHasTextOrGeoposition: true};
}

function checkIfHasAtLeastOneHostSelected(group: FormGroup): IValidators | null {
    const host: AbstractControl = group.get(['host']);
    return host && host.value && host.value.length > 0 ? null : {checkIfHasAtLeastOneHostSelected: true};
}

interface IConfigQuantity {
    max: string | [string, number];
    default: number;
}

interface IConfigNight {
    min: number;
    default: number;
}

interface IConfigPax {
    max: {
        addition: string[];
    };
    value: number;
}

interface IConfigRating {
    exist: boolean;
    visible: boolean;
    numberOfStars?: number;
}

interface IConfigTraveller {
    default: number;
    min: number;
    max: number;
}

interface ISearchFormConfig {
    brand: string;
    hosts: string[];
    quantity: {
        adult: IConfigQuantity;
        child: IConfigQuantity;
        infant: IConfigQuantity;
        night: IConfigNight;
        pax: IConfigPax;
        rooming: IConfigQuantity;
    };
    ratings: {
        brand: IConfigRating;
        brandCheckbox: IConfigRating;
        standardisationBody: IConfigRating;
        traveller: IConfigRating;
    };
    selectedHosts: string[];
    traveller: {
        adult: IConfigTraveller;
        child: IConfigTraveller;
        infant: IConfigTraveller;
    };
}

interface IRoomingCounts {
    adult: number;
    child: number;
    infant: number;
}


@Component({
    selector: 'search-hotel-form',
    templateUrl: './search-hotel-form.component.html',
    styleUrls: ['./search-hotel-form.component.scss'],
    providers: [SearchHotelFormService],
})
export class SearchHotelFormComponent extends GenericForm implements OnInit, OnDestroy {

    public labels: { [key: string]: string } = {
        location: Yii.t('wui-shared-js', 'Lieu'),
        latitude: Yii.t('wui-shared-js', 'Latitude'),
        longitude: Yii.t('wui-shared-js', 'Longitude'),
        geoposition: Yii.t('wui-shared-js', 'Géoposition'),
    };

    @Output()
    public readonly onSubmitForm: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    public config: Config = new Config();

    @Input()
    public data: any; // TODO Interface

    @Input()
    public hasRightToShowMap: boolean = true;

    @Input()
    public request: any; // TODO Interface

    @Input()
    public travellers: ITraveller[];

    @Input()
    public quantities?: IQuantity;

    //Prod hotel
    @Input()
    public isGlobalSearch?: boolean = false;

    @Input()
    public isUnitSearch?: boolean = false;

    @Input()
    public blockId?: number;

    @ViewChild('text', {static: true})
    public text: TemplateRef<HTMLElement>;

    @ViewChild('locationName', {static: true})
    public locationName: TemplateRef<HTMLElement>;

    @ViewChild('filters', {static: true})
    public filters: TemplateRef<HTMLElement>;

    @ViewChild('address', {static: true})
    public address: TemplateRef<HTMLElement>;

    @ViewChild('segment', {static: true})
    public segment: TemplateRef<HTMLElement>;

    @ViewChild('advancedFilters', {static: true})
    public advancedFilters: TemplateRef<HTMLElement>;

    @ViewChild('quantity', {static: true})
    public quantity: TemplateRef<HTMLElement>;

    @ViewChild('rooming', {static: true})
    public rooming: TemplateRef<HTMLElement>;

    @ViewChild('map', {static: true})
    public map: TemplateRef<HTMLElement>;

    @ViewChild('brandCheckbox', {static: true})
    public brandCheckbox: Checkbox;


    public searchInput: string = '';

    public hostsList: Array<{ label: string; value: string }> = [];
    public showMap: boolean = false;
    public selectedHosts: string[] = [];

    public wording: ILabels = WORDING;
    public fieldConfig: { [key: string]: any }; // TODO Interface
    public ratingsConfig: {
        standardisationBody: { exist: boolean; visible: boolean; numberOfStars?: number; };
        brand: { exist: boolean; visible: boolean; numberOfStars?: number; };
        brandCheckbox: { exist: boolean; visible: boolean; };
        traveller: { exist: boolean; visible: boolean; numberOfStars?: number; };
    };

    public showAdvancedFilters: boolean = false;

    public mapConfig = {
        hasOffer: false,
        hasList: false,
        searchMap: {
            active: true,
            placeholder: Yii.t('wui-shared-js', 'Rechercher')
        }
    };
    public dispatchingIsOpen: boolean = false;
    public travellerInformations: {
        adult: any; // TODO Interface
        child: any; // TODO Interface
        infant: any; // TODO Interface
    };

    public errorIsReady: boolean = false;
    public brandStateChecked: boolean = false;
    public isOnlyRefundable: boolean = true;
    public error: string;
    public tagsList: IMultiselectOptions[] = [];

    public geoposition: {
        latitude: number;
        longitude: number;
        radius: {
            unit: string;
            max: number;
        }
    };

    public iconCaretRight: IconDefinition = faCaretRight;
    public iconCaretDown: IconDefinition = faCaretDown;
    public iconDown: IconDefinition = faChevronDown;
    public iconUp: IconDefinition = faChevronUp;
    public iconRight: IconDefinition = faChevronRight;
    public iconLeft: IconDefinition = faChevronLeft;
    public labelPosition: ELabelPosition = ELabelPosition.right;

    public iconSearch: IconDefinition = faSearch;

    public permissions: typeof EStayPermissions = EStayPermissions;

    private repartition: ITravellerRepartition = {}; // TODO Interface

    public initialLocationName: string;
    public initialLocationArray: ILocation[];

    private inputGeoposition: {
        latitude: number;
        longitude: number;
        radius: {
            unit: string;
            max: number;
        }
    };

    public geopositionLabel: string;

    private readonly subscription: Subscription = new Subscription();

    private formattedRepartition: IRepartition;

    // Use default data when form is resetting
    private defaultAppData: any; // TODO Interface

    private readonly travellersError: { adult: boolean; infant: boolean; child: boolean } = {
        adult: false,
        child: false,
        infant: false
    };

    private hasRepartitionError: boolean = false;

    constructor(
        public fb: FormBuilder,
        private readonly searchHotelFormService: SearchHotelFormService,
        private readonly geopositionService: GeopositionService,
        private readonly travellerService: TravellerService,
        private readonly dateService: DateService,
        private readonly errorTracingService: ErrorTracingService,
        private readonly hostAliasService: HostAliasResource,
        private readonly languageService: LanguageService,
        protected readonly permissionResourceService: PermissionResourceService,
        //besoin de l'injecter dans le module de iaqoboHotel mais je sais pas si fesable @Inject('ItemService') private readonly itemService: any,
        public formService?: FormService,
        public http?: HttpClient,
    ) {
        super(fb, formService);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.initIsOnlyRefundable();
        // listenQuantities() has to be called before getAppDefault()
        this.listenQuantitiesChanges();
        if (this.request && this.request.segment[0].property.geoposition) {
            this.geoposition = this.request.segment[0].property.geoposition;
            this.inputGeoposition = this.geoposition;
            this.showMap = true;
        }
        if (this.request &&
            this.request.segment &&
            Array.isArray(this.request.segment) &&
            this.request.segment.length &&
            this.request.segment[0].property &&
            this.request.segment[0].property.locationName) {
            /*
            #30529 : we don't bind the name with the leafetmap input search. In case
            we have selected Yosemite National Park(US) with geoposition in the location text
            field we're gonna have only Yosemite so the map will be centered in the wrong place (Australia)
            this.searchInput = this.request.segment[0].property.locationName;
             */
            this.initialLocationName = this.request.segment[0].property.locationName;
            this.initialLocationArray = this.request.segment[0].property.locationArray;
        }
        this.initForm().pipe(
            tap(() => {
                if (this.request) {
                    this.patchExistingValues();
                    this.patchLocationToSearchInput();
                }
            })).subscribe({
            error: console.error.bind(console)
        });


        this.form.get('rooming').valueChanges
            .subscribe(
                (data) => {
                    this.getRepartitionErrors();
                }, console.error.bind(console));

        if (this.request) {
            const requestSegmentRooming = get(this.request, ['segment', 0, 'rooming']);
            const requestTraveller = get(this.request, 'traveller');

            //patch form repartition if we have datas in request
            if (requestSegmentRooming && requestTraveller) {
                const travellersLength: any[] = [];
                forEach(requestSegmentRooming, (room: { traveller: string[] }) => {
                    travellersLength.push(repartitionByRoom(requestTraveller, room.traveller));
                });

                this.form.get('rooming').patchValue(travellersLength);
            }
        }

        this.fieldConfig = {
            standardisationBody:
                getFieldConfig('standardisationBody', 'min',
                    this.form.get(['segment', 0, 'property', 'rating', 'standardisationBody']) as FormGroup),
            traveller:
                getFieldConfig('traveller', 'min',
                    this.form.get(['segment', 0, 'property', 'rating', 'traveller']) as FormGroup),
            brand:
                getFieldConfig('brand', 'min',
                    this.form.get(['segment', 0, 'property', 'rating', 'brand']) as FormGroup),
        };

        this.form.get(['segment', 0, 'property', 'rating', 'brand', 'min']).valueChanges.subscribe((minValue: number) => {
            this.brandStateChecked = minValue > 0;
        });
        this.setValidators();

    }

    private initIsOnlyRefundable(): void {
        if (!this.request || this.request && this.request.isOnlyRefundable === undefined) {
            this.permissionResourceService.hasPermission('shared.stay.quoteWithFees.view').subscribe((viewIsOnlyRefundable: boolean) => {
                this.isOnlyRefundable = !viewIsOnlyRefundable;
            });
        } else {
            this.isOnlyRefundable = this.request.isOnlyRefundable;
        }
    }

    public ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    public cancel(request: ISearchRequest): void {
        this.initForm().pipe(
            tap(() => {
                if (request) {
                    this.patchExistingValues();
                    this.patchLocationToSearchInput();
                }
            })).subscribe({
            error: console.error.bind(console)
        });
    }

    public get invalid(): boolean {
        return Boolean(this.form && this.form.invalid);
    }

    public hasTravellers(): boolean {
        return Boolean(this.travellers && this.travellers.length > 0);
    }


    public reset(): void {
        super.reset();
        this.initForm().subscribe();
    }

    public onBrandCheckboxChange(): void {
        const minBrandField: AbstractControl = this.form.get(['segment', 0, 'property', 'rating', 'brand', 'min']);
        if (this.brandStateChecked &&
            (minBrandField.value === null || minBrandField.value === 0 || minBrandField.value === '')
        ) {
            minBrandField.patchValue(1);
        }
        if (!this.brandStateChecked && isNumber(minBrandField.value) && minBrandField.value > 0) {
            minBrandField.patchValue(0);
        }
    }

    public onBrandRatingChange(): void {
        const minBrandField: number | string = this.form.get(['segment', 0, 'property', 'rating', 'brand', 'min']).value;
        const isMinBrandField: boolean = minBrandField === null || minBrandField === 0 || minBrandField === '';
        this.ratingsConfig.brandCheckbox = {
            exist: isMinBrandField,
            visible: isMinBrandField,
        };
    }

    public getGeoposition(geoposition: {
        latitude: number;
        longitude: number;
        radius: {
            unit: string;
            max: number;
        }
    }): void {
        this.inputGeoposition = geoposition;
        this.form.get(['segment', 0, 'property', 'geoposition']).patchValue(geoposition);
    }

    public toggleMap(): void {
        this.showMap = !this.showMap;

        if (!this.showMap) {
            this.form.get(['segment', 0, 'property', 'geoposition']).reset();
        }
    }

    public patchDefaultValues(defaultAppData: ISearchFormConfig, repartition: ITravellerRepartition, hostAliases: IHostAlias[]): void { // TODO Interface
        this.hostsList = transformHostsResponseToLabelValue(defaultAppData.hosts, hostAliases);

        this.form.get(['segment', 0, 'duration', 'night']).patchValue(defaultAppData.quantity.night.default);
        this.travellerInformations = defaultAppData.traveller;

        const defaultQuantities: IQuantity = {
            adult: defaultAppData.quantity.adult.default,
            child: defaultAppData.quantity.child.default,
            infant: defaultAppData.quantity.infant.default,
            rooming: defaultAppData.quantity.rooming.default
        };

        const parentQuantities: IQuantity = {
            ...this.quantities,
            rooming: defaultAppData.quantity.rooming.default
        };

        const quantitiesToUse: IQuantity = this.quantities ? parentQuantities : defaultQuantities;
        this.patchQuantities(quantitiesToUse);

        this.formattedRepartition = this.getRepartition(quantitiesToUse, repartition);

        this.patchHosts(defaultAppData.hosts, defaultAppData.selectedHosts);
        this.patchTravellersByRoom();
    }

    public getHostConfig(index: number): IFieldSpecs {
        return {
            formGroup: this.form.get(['segment', index, 'property']) as FormGroup,
            formControlName: 'host',
            // label: Yii.t('wui-shared-js', 'Fournisseurs'),
        };
    }

    public getKeywordConfig(index: number): IFieldSpecs {
        return {
            formGroup: this.form.get(['segment', index, 'property']) as FormGroup,
            formControlName: 'keyword',
            // label: WORDING.tags,
        };
    }

    public submit({value, valid}: { value: any, valid: boolean }): void { // TODO Interface
        if ((valid && !this.hasRepartitionError) || this.isGlobalSearch || this.isUnitSearch) {
            this.error = undefined;
            let geoposition: IAfiGeoposition = null;

            if (this.inputGeoposition && this.showMap) {
                geoposition = this.inputGeoposition;
            }

            const brand = this.defaultAppData?.brand;

            value.segment[0].property.rating
                .standardisationBody.max = this.ratingsConfig.standardisationBody.numberOfStars;
            value.segment[0].property.rating.traveller.max = this.ratingsConfig.traveller.numberOfStars;
            value.segment[0].property.rating.brand.max = this.ratingsConfig.brand.numberOfStars;
            value.segment[0].property.rating.brand.min = value.segment[0].property.rating.brand.min ?
                value.segment[0].property.rating.brand.min : 0;

            const hasGeoposition: boolean = !this.geopositionService.isEmpty(geoposition);

            const segment = {
                ...value.segment[0],
                ...this.createRoomingObject(value),
                property: {
                    ...value.segment[0].property,
                    text: value.segment[0].property.text,
                    location: value.segment[0].property.locationName,
                    locationArray: this.initialLocationArray
                }
            };
            /* #30529 JSV : if geoposition is used we skip the location
            * */
            if (hasGeoposition) {
                segment.property.location = null;
                segment.property.geoposition = geoposition;
                this.form.get(['segment', 0, 'property', 'geoposition']).patchValue(geoposition);
            } else {
                delete segment.property.geoposition;
                this.form.get(['segment', 0, 'property', 'geoposition']).reset();
            }

            // #30529 JSV no needed values
            if (segment.property.city) {
                delete segment.property.city;
            }

            const request = {
                brand,
                blocks: this.request?.blocks,
                language: this.languageService.userLanguage,
                // city: value.city,
                keyword: value.keyword,
                quantity: value.quantity,
                traveller: this.buildTravellers(value),
                segment: [segment],
                isOnlyRefundable: this.isOnlyRefundable
            };

            // This must be emitted before setting the data
            // because otherwise the parent component
            // won't be notified (it will be destroyed before)
            this.onSubmitForm.emit(this.formService.removeEmptyObjectsAndFormatDate(request));
            if (!this.isUnitSearch) {
                this.formService.setData(request);
            }

        } else {
            this.error = Yii.t("wui-shared-js", "Le formulaire contient des erreurs. Vérifiez que vous avez renseigné tous les champs et que la répartition est correcte.");
            const geoposition: AbstractControl = this.form.get(['segment', 0, 'property']).get(['geoposition', 'longitude']);
            const locationName: AbstractControl = this.form.get(['segment', 0, 'property']).get('locationName');
            this.error += (locationName.value || geoposition.value) ? '' : Yii.t("wui-shared-js", " Veuillez sélectionner un lieu");
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

    public showDispatching(): void {
        if (!this.dispatchingIsOpen) {
            this.dispatchingIsOpen = this.travellersError.adult ||
                this.travellersError.child ||
                this.travellersError.infant;
        }
    }

    /**
     * Compute repartition errors
     */
    public getRepartitionErrors(): string {

        const rooms: FormArray = this.form.get('rooming') as FormArray;

        const nbrOfSettedTravellers: IRoomingCounts = {
            adult: 0,
            child: 0,
            infant: 0
        };

        rooms.controls.forEach((room) => {
            nbrOfSettedTravellers.adult += room.get('adult').value;
            nbrOfSettedTravellers.child += room.get('child').value;
            nbrOfSettedTravellers.infant += room.get('infant').value;
        });

        const travellers = this.form.get('quantity');
        const adult = travellers.get('adult').value;
        const child = travellers.get('child').value;
        const infant = travellers.get('infant').value;

        const travellersErrorMessage: string = Yii.t("wui-shared-js", "Le nombre de voyageurs ne correspond pas : ");

        let errorMessage =
            this.travellersError.adult
            || this.travellersError.child
            || this.travellersError.infant ? travellersErrorMessage : '';

        if (adult !== nbrOfSettedTravellers.adult) {
            const diff = Math.abs(adult - nbrOfSettedTravellers.adult);
            errorMessage += `${diff}  ADT`;

            this.travellersError.adult = true;
        } else {
            this.travellersError.adult = false;
        }

        if (child !== nbrOfSettedTravellers.child) {
            const diff = Math.abs(child - nbrOfSettedTravellers.child);

            if (this.travellersError.adult) {
                errorMessage += ' et ';
            }

            errorMessage += `${diff} CHD`;

            this.travellersError.child = true;
        } else {
            this.travellersError.child = false;
        }

        if (infant !== nbrOfSettedTravellers.infant) {
            const diff = Math.abs(infant - nbrOfSettedTravellers.infant);

            if (this.travellersError.adult || this.travellersError.child) {
                errorMessage += ' et ';
            }

            errorMessage += `${diff} INF`;
            this.travellersError.infant = true;
        } else {
            this.travellersError.infant = false;
        }

        if (errorMessage && errorMessage !== '') {
            this.form.setErrors({checkIfHasTextOrGeoposition: true});
        } else if (!errorMessage || (errorMessage && errorMessage === '')) {
            this.form.setErrors(null);
        }

        this.hasRepartitionError = errorMessage && errorMessage !== "";
        return errorMessage;
    }

    public getSegments(): FormArray {
        return this.form.get('segment') as FormArray;
    }

    public getChild(): FormArray {
        return this.form.get('child') as FormArray;
    }

    public getInfant(): FormArray {
        return this.form.get('infant') as FormArray;
    }

    public getRooming(): FormArray {
        return this.form.get('rooming') as FormArray;
    }

    /* #30529 JSV : public function to determine if geoposition
    * has been set */
    public isGeopositionSet() {
        return (this.inputGeoposition !== null
            && this.inputGeoposition !== undefined
            && this.inputGeoposition.latitude !== null
            && this.inputGeoposition.longitude !== null);
    }

    /** Init search hotel form with default data and default repartition */
    private initForm(): Observable<[ISearchFormConfig, ITravellerRepartition, IMultiselectOptions[], IHostAlias[]]> {
        const getRepartitionDataSource: Observable<ITravellerRepartition> = this.searchHotelFormService.getRepartitionData();
        const getHotelFormConfigSource: Observable<ISearchFormConfig> = observableOf(this.defaultAppData).pipe(
            mergeMap((hotelFormConfig: ISearchFormConfig) => hotelFormConfig ? observableOf(hotelFormConfig) : this.searchHotelFormService.getAppDefault()));

        const getTagsConfigSource: Observable<IMultiselectOptions[]> = this.searchHotelFormService.getTagsData().pipe(
            pluck('Accomodation'),
            filter((tags: ITag[]) => tags && tags.length > 0),
            mergeMap((tags: ITag[]) => tags),
            map((tag: ITag): IMultiselectOptions => ({
                value: tag.code,
                label: tag.label && tag.label[wenji.ui.language] || tag.code
            })),
            reduce((acc: IMultiselectOptions[], curr: IMultiselectOptions): IMultiselectOptions[] => [...acc, curr], []),
            catchError((error: Error) => {
                this.errorTracingService.captureException(error);
                return observableOf([]);
            }));

        return observableForkJoin<ISearchFormConfig, ITravellerRepartition, IMultiselectOptions[], IHostAlias[]>(
            getHotelFormConfigSource,
            getRepartitionDataSource,
            getTagsConfigSource,
            this.hostAliasService.getAllAliases()
        ).pipe(
            // Patch config values
            tap(([hotelFormConfig, repartition, tagsList, hostAliases]: [ISearchFormConfig, ITravellerRepartition, IMultiselectOptions[], IHostAlias[]]) => {
                // Caches
                this.repartition = repartition;
                this.defaultAppData = hotelFormConfig;
                this.tagsList = tagsList;
                this.errorIsReady = true;

                this.patchDefaultValues(hotelFormConfig, repartition, hostAliases);

                this.ratingsConfig = hotelFormConfig.ratings;
            }));

        if (this.request && this.request.segment[0].property.geoposition) {
            this.form.get(['segment', 0, 'property', 'geoposition']).patchValue(this.request.segment[0].property.geoposition);
        }
        if (this.request &&
            this.request.segment &&
            Array.isArray(this.request.segment) &&
            this.request.segment.length &&
            this.request.segment[0].property &&
            this.request.segment[0].property.locationName) {
            /*
            #30529 : we don't bind the name with the leafetmap input search. In case
            we have selected Yosemite National Park(US) with geoposition in the location text
            field we're gonna have only Yosemite so the map will be centered in the wrong place (Australia)
            this.searchInput = this.request.segment[0].property.locationName;
             */
            this.form.get(['segment', 0, 'property', 'locationName']).patchValue(this.request.segment[0].property.locationName);
        }
        this.form.get('quantity').patchValue(this.request.quantity);
    }

    private setValidators(): void {
        this.form.get(['segment', 0, 'property'])
            .setValidators([checkIfHasTextOrGeoposition, checkIfHasAtLeastOneHostSelected]);
        //has to be here, because quantityGroup is also used by Air, which contains no rooms
        this.form.get(['quantity', 'rooming'])
            .setValidators([Validators.required, Validators.min(1)]);
    }

    private patchExistingValues(): void {
        const segments = this.form.get('segment') as FormArray;

        segments.controls.forEach((segment, i) => {
            let seg = this.request.segment[i];
            seg = {
                ...seg || {},
                begin: new Date(this.dateService.getStr2JsDate(seg.begin)),
                end: new Date(this.dateService.getStr2JsDate(seg.end)),
            };

            if(!seg?.property?.keyword){
                seg.property = {
                    ...seg.property,
                    keyword: []
                };
            }

            if(seg?.property?.rating?.standardisationBody?.min === undefined){
                seg.property = {
                    ...seg.property,
                    rating: {
                        ...seg.property.rating,
                        standardisationBody: {
                            ...(seg.property.rating && seg.property.rating.standardisationBody),
                            min: 0
                        }
                    }
                };
            }

            if(seg?.property?.rating?.traveller?.min === undefined){
                seg.property = {
                    ...seg.property,
                    rating: {
                        ...seg.property.rating,
                        traveller: {
                            ...seg.property.rating.traveller,
                            min: 0
                        }
                    }
                };
            }

            if(seg?.property?.rating?.brand?.min === undefined){
                seg.property = {
                    ...seg.property,
                    rating: {
                        brand: {
                           ...seg.property.rating.brand,
                            min: 0
                        }
                    }
                };
            }

            if (this.inputGeoposition) {
                seg.property.geoposition = this.inputGeoposition;
                this.geopositionLabel = this.geopositionService.getGeopositionLabel(this.inputGeoposition);
            } else {
                seg.property.geoposition = {
                    latitude: null,
                    longitude: null,
                    radius: {
                        unit: null,
                        max: null
                    }
                };
            }
            segment.patchValue(seg);

        });

        this.form.get('quantity').patchValue(this.request.quantity);
        this.form.get('keyword').patchValue(this.request.keyword);


        this.patchTravellersByRoom();
        if (this.request.traveller) {
            this.patchAges();
        }
    }

    private patchAges(): void {
        const children = Object.values(this.request.traveller).filter((traveller: any) => { // TODO Interface
            return traveller.type.toLowerCase() === 'child';
        });

        const infants = Object.values(this.request.traveller).filter((traveller: any) => { // TODO Interface
            return traveller.type.toLowerCase() === 'infant';
        });

        this.form.get('child').patchValue(children);
        this.form.get('infant').patchValue(infants);
    }

    private patchLocationToSearchInput(): void {
        const segments = this.form.get('segment') as FormArray;
        segments.controls.forEach((segment: AbstractControl): void => {
            const segmentObs = segment.get(['property', 'locationName'])
                .valueChanges
                .subscribe((value: string): void => {
                    /*
                    #30529 : we don't bind the name with the leafetmap input search. In case
                    we have selected Yosemite National Park(US) with geoposition in the location text
                    field we're gonna have only Yosemite so the map will be centered in the wrong place (Australia)
                    this.searchInput = this.request.segment[0].property.locationName;
                     */
                    if (this.initialLocationName !== value) {
                        delete this.inputGeoposition;
                        this.form.get(['segment', 0, 'property', 'geoposition']).reset();
                    }
                });
            this.subscription.add(segmentObs);
        });
    }

    private listenQuantitiesChanges(): void {
        const quantities = this.form.get('quantity') as FormGroup;

        this.subscription.add(
            quantities.valueChanges.pipe(
                tap((newQuantities: IQuantity): void => {

                    this.addRemoveQuantityField(
                        newQuantities.rooming,
                        'rooming',
                        this.addRoom.bind(this),
                        this.removeRoom.bind(this)
                    );

                    if (!this.dispatchingIsOpen) {
                        // si le quantityChanged === this.request.quantity ?
                        // et que this.request a déjà une répartition ?
                        // alors à la place de ce qui suit
                        if (this.request && isEqual(newQuantities, this.request.quantity)) {
                            this.formattedRepartition = this.getRepartitionFromRequest();
                        } else {
                            this.formattedRepartition = this.getRepartition(newQuantities, this.repartition);
                        }

                        // on set this.formattedRepartition à null ou avec les infos de répartition de this.request

                        if (this.formattedRepartition &&
                            this.formattedRepartition.rooming &&
                            this.formattedRepartition.traveller &&
                            Object.keys(this.formattedRepartition.rooming).length === newQuantities.rooming
                        ) {
                            this.patchRepartition(this.formattedRepartition);
                        }
                        //#30177 : removed here : automatic opening when incorrect
                    }

                    this.addRemoveQuantityField(
                        newQuantities.child,
                        'child',
                        this.addChildAge.bind(this),
                        this.removeChildAge.bind(this)
                    );
                    this.addRemoveQuantityField(
                        newQuantities.infant,
                        'infant',
                        this.addInfantAge.bind(this),
                        this.removeInfantAge.bind(this)
                    );
                }))
                .subscribe()
        );
    }

    private addRemoveQuantityField(newNumber: number, name: string, add: () => void, remove: () => void): void {
        const oldNumber: number = (this.form.get(name) as FormArray).length;
        const times: number = newNumber - oldNumber;

        if (times > 0) {
            let count: number = 0;

            while (count < times) {
                add();
                count++;
            }
        } else if (times < 0) {
            let count: number = 0;
            const loopTimes: number = Math.abs(times);

            while (count < loopTimes) {
                remove();
                count++;
            }
        }
    }

    private getRepartitionFromRequest(): IRepartition {
        const rooming: IRooming = this.request.segment[0].rooming;

        return {
            rooming,
            traveller: this.request.traveller
        };
    }

    private createRoomingObject(values): { rooming: { [key: string]: { traveller: string[] } } } {
        const rooming = values.rooming;

        const travellers = this.buildTravellers(values);
        const formattedRooming = {};

        rooming.forEach((room, index: number) => {
            const selectedTravellersIds = this.searchHotelFormService.getTravellers(room, travellers);
            selectedTravellersIds.forEach((id: string) => {
                delete travellers[id];
            });

            formattedRooming[`R${index + 1}`] = {
                traveller: selectedTravellersIds,
            };
        });

        return {rooming: {...formattedRooming}};
    }

    private buildTravellers(values): any {

        if (this.hasTravellers()) {
            return this.travellerService.generateTravellersObject(this.travellers);
        }

        return {...this.searchHotelFormService.createTravellersObject(values, this.form)};
    }

    private patchRepartition(repartition: any): void { // TODO Interface
        this.patchRooming(Object.keys(repartition.rooming).length);
        this.patchTravellersByRoom();
    }

    private patchTravellersByRoom(): void {
        const rooms: FormArray = this.form.get('rooming') as FormArray;
        const travellersLength: any[] = []; // TODO Interface
        rooms.controls.forEach((room, index: number) => {
            if (this.formattedRepartition &&
                this.formattedRepartition.traveller &&
                this.formattedRepartition.rooming
            ) {
                const rooming = this.formattedRepartition.rooming[`R${index + 1}`];

                if (rooming) {
                    travellersLength.push(
                        repartitionByRoom(this.formattedRepartition.traveller as any, rooming.traveller)
                    );
                }
            }
        });
        this.form.get('rooming').patchValue(travellersLength);
    }

    private patchRooming(currentRoomsCount: number): void {
        if (currentRoomsCount !== this.form.get(['quantity', 'rooming']).value) {
            this.form.get(['quantity', 'rooming']).patchValue(currentRoomsCount);
        }
    }

    private addChildAge(): void {
        const defaultAge: number = this.travellerInformations ?
            this.travellerInformations.child.age.default : 0;

        (this.form.get('child') as FormArray).push(this.fb.group({
            type: ['Child'],
            age: [defaultAge],
        }));
    }

    private removeChildAge(): void {
        const child: FormArray = this.form.get('child') as FormArray;
        (this.form.get('child') as FormArray).removeAt((child.length - 1));
    }

    private addInfantAge(): void {
        const defaultAge: number = this.travellerInformations ?
            this.travellerInformations.infant.age.default : 0;

        (this.form.get('infant') as FormArray).push(this.fb.group({
            type: ['Infant'],
            age: [defaultAge],
        }));
    }

    private removeInfantAge(): void {
        const infant: FormArray = this.form.get('infant') as FormArray;
        (this.form.get('infant') as FormArray).removeAt((infant.length - 1));
    }

    private addRoom(): void {
        (this.form.get('rooming') as FormArray).push(this.fb.group({
            adult: [0],
            child: [0],
            infant: [0]
        }));

        this.patchTravellersByRoom();
    }

    private removeRoom(): void {
        const room: FormArray = this.form.get('rooming') as FormArray;
        (this.form.get('rooming') as FormArray).removeAt((room.length - 1));
    }

    private patchQuantities(repartition): void {
        this.form.get(['quantity']).patchValue(repartition);
    }

    private getRepartition(quantities: IQuantity, repartition: ITravellerRepartition): IRepartition {
        const formattedQuantities: string = this.searchHotelFormService.transformFormQuantitiesToJsonFormat(quantities);
        return repartition[formattedQuantities];
    }

    private patchHosts(hosts: string[], selectedHosts: string[]): void {
        const segments: FormArray = this.form.get('segment') as FormArray;
        segments.controls.forEach((segment: AbstractControl) => {
            segment.get(['property', 'host']).patchValue(selectedHosts);
        });
    }
}

function transformHostsResponseToLabelValue(hosts: string[], hostAliases: IHostAlias[]): Array<{ label: string, value: string }> {
    return (hosts || []).map((host: string) => {
        const alias: IHostAlias = hostAliases.find((curAlias: IHostAlias): boolean => {
            return curAlias.host === host;
        });
        return {label: alias ? alias.alias : host, value: host};
    });
}

function repartitionByRoom(travellerObject: ITraveller, travellers: string[]): IRoomingCounts {
    const repartition: IRoomingCounts = {
        adult: 0,
        child: 0,
        infant: 0
    };

    travellers.forEach((travellerId: string) => {
        const travellerItem: ITravellerObject = travellerObject[travellerId];
        if (travellerItem) {
            if (travellerItem.type.toLowerCase() === 'adult') {
                repartition.adult = repartition.adult + 1;
            }

            if (travellerItem.type.toLowerCase() === 'child') {
                repartition.child = repartition.child + 1;
            }

            if (travellerItem.type.toLowerCase() === 'infant') {
                repartition.infant = repartition.infant + 1;
            }
        }
    });

    return repartition;
}
